module.exports = __webpack_public_path__ + "static/media/food-2.fdfa9b29.png";